import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { UserService } from 'src/app/users/services/user.service';
import { AuthService } from 'src/app/core/auth/auth.service';
import {ToastrService} from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {

  registerForm: FormGroup;

  constructor(
    private userService: UserService,
    public authService: AuthService,
    private router: Router,
    private fb: FormBuilder,
    private toastr: ToastrService,
    public translate: TranslateService) {
      this.createForm();
    }

  ngOnInit(): void {
    this.initFormGroupControls();
  }

  createForm(): void {
    this.registerForm = this.fb.group({
      email: ['', Validators.required ],
      password: ['', Validators.required],
      firstName: ['', Validators.required ],
      lastName: ['', Validators.required]
    });
  }

  private initFormGroupControls(): void {
    this.registerForm = new FormGroup({
      password: new FormControl('', [Validators.required, Validators.minLength(6)]),
      email: new FormControl('', [Validators.required, Validators.email]),
      firstName: new FormControl('', [Validators.required]),
      lastName: new FormControl('', [Validators.required])
    });
  }

  private isFormValid(formGroup: FormGroup): boolean {
    return formGroup.valid;
  }

  register(): void {
    if (this.isFormValid(this.registerForm)) {
      this.authService.registerAndUpdate(this.registerForm.value)
        .then(() => {
          this.router.navigate(['/profile']);
          this.setUserToken();
        })
        .catch((error) => {
          if (error.code.startsWith('auth/')) {
            this.toastr.error(error.message);
          } else {
            this.translate.get('GENERAL.ERROR').subscribe((text: string) => {this.toastr.error(text); });
          }
        });
    } else {
      // TODO handle errors correctly
      console.error('Form is invalid', this.registerForm);
    }
  }

  private setUserToken(): void {
    this.authService.getCurrentUserToken();
  }

  signInWithGoogle(): void {
    this.authService.signInWithGoogle()
      .then(() => {
        this.router.navigate(['/lectures']);
        this.setUserToken();
      })
      .catch((error) => {
        this.toastr.error(error.message, 'Error!');
      });
  }

  signInWithFacebook(): void {
    this.authService.signInWithFacebook()
      .then(() => {
        this.router.navigate(['/lectures']);
        this.setUserToken();
      })
      .catch((error) => {
        this.toastr.error(error.message, 'Error!');
      });
  }
}
